import React from 'react';
import Col from 'react-bootstrap/Col';
import Slider from 'react-slick';
import properties from '../../../modules/ajio-util/properties';
import { getImageNameForGTMPromotion } from '../../../modules/ga/gtmLandingPageMethods';
import BannerWrapper from '../../BannerWrapper';
import { replaceWithJioCDN } from '../../../utils/imageHandling';

class NativeFeatureHeroGridCarousel extends React.Component {
  render() {
    const pagedetails = this.props.pagedetails;
    const bannerDetail = pagedetails.bannerImageDetails;
    const widgetType = pagedetails.typeCode;
    const sectionName = this.props.componentTitle
      ? this.props.componentTitle
      : pagedetails.typeCode;
    if (bannerDetail === undefined) {
      return null;
    }
    let heroImage = null;
    let heroImgUrl = '';
    heroImgUrl =
      pagedetails.heroBanner.imageUrl.indexOf('?') == -1
        ? pagedetails.heroBanner.imageUrl
        : pagedetails.heroBanner.imageUrl.substr(0, pagedetails.heroBanner.imageUrl.indexOf('?'));
    heroImage = (
      <Col xs={7} className="hero-image">
        <a
          href={pagedetails.heroBanner.bannerUrlLink}
          data-ga-event-category="bannerTap"
          data-ga-event-action={`${sectionName}/${pagedetails.heroBanner.componentPosition}/${widgetType}`}
          data-ga-event-label={`${heroImgUrl}/${pagedetails.heroBanner.bannerPosition}`}
          data-gtm-bnr-position={`${pagedetails.heroBanner.componentPosition}`}
          data-gtm-bnr-imgname={`${getImageNameForGTMPromotion(pagedetails.heroBanner.imageUrl) ||
            ''}`}
          data-gtm-bnr-id={`${pagedetails.heroBanner.uId || ''}`}
        >
          <img src={`${replaceWithJioCDN(pagedetails.heroBanner.imageUrl)}`} className="img-animate" />
        </a>
      </Col>
    );

    const imageGallery = bannerDetail.map((bannerimagedetails, i) => {
      let bannerImgUrl = '';
      bannerImgUrl =
        bannerimagedetails.imageUrl.indexOf('?') == -1
          ? bannerimagedetails.imageUrl
          : bannerimagedetails.imageUrl.substr(0, bannerimagedetails.imageUrl.indexOf('?'));
      return (
        <a
          href={bannerimagedetails.bannerUrlLink}
          key={i}
          data-ga-event-category="bannerTap"
          data-ga-event-action={`${sectionName}/${bannerimagedetails.componentPosition}/${widgetType}`}
          data-ga-event-label={`${bannerImgUrl}/${bannerimagedetails.bannerPosition}`}
          data-gtm-bnr-position={`${bannerimagedetails.componentPosition}`}
          data-gtm-bnr-imgname={`${getImageNameForGTMPromotion(bannerimagedetails.imageUrl) || ''}`}
          data-gtm-bnr-id={`${bannerimagedetails.uId || ''}`}
        >
          <img src={`${replaceWithJioCDN(pagedetails.heroBanner.imageUrl)}`} className="img-animate" />
        </a>
      );
    });

    return (
      <div className="gallery-com row">
        {heroImage}
        <Col xs={5} className="gallery-section">
          {imageGallery}
        </Col>
      </div>
    );
  }
}

export default BannerWrapper(NativeFeatureHeroGridCarousel);
